<template>
    <div class="loader_container">
        <div class="loader_box">
            <div class="loader_logo">
                <a href="/" title="精诚时代">
                    <img src="../assets/logo-white.png" alt="精诚时代" />
                </a>
                <div class="slogan">
                    <p v-if="lang == 'cn'">让全球用户<br />享用高品质模头</p>
                    <span :class="[{'loader_active':lang === 'en'}]">Delivering high-quality dies to customers worldwide.</span>
                </div>
            </div>
            <div class="jindu">
              <div class="progress_bar">
                  <div class="speed" :style="{width:speed + '%'}"></div>
              </div>
              <div class="speed_text"><span>{{ parseInt(speed) }}</span>%</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Loader',
        props: {
            speed: Number
        },
        data(){
          return {
            lang: 'cn',
          }
        },
        mounted(){
          if(sessionStorage.getItem('language')){
            this.lang = sessionStorage.getItem('language'); // 存入一个值
          }else{
            sessionStorage.setItem('language',this.lang); // 存入一个值
          }
        },
    }
</script>
<style scoped>
    .loader_container{
        width: 100%;
        height: 100vh;
        position: relative;
        z-index: 9999;
        background-image: url(../assets/images/loader-bg.jpg);
        background-size: cover;
        background-position: center;
    }
    .loader_box{
        width: 100%;
        top: 50%;
        display: flex;
        align-items: center;
        position: absolute;
        transform: translate(0, -50%);
        padding: 0 6.71875%;
    }
    .loader_box .loader_logo{
        width: 350px;
        flex: 0 0 auto;
    }
    .loader_box .loader_logo a{
        display: block;
    }
    .loader_box .loader_logo img{
        display: block;
        height: 45px;
    }
    .loader_box .loader_logo .slogan{
        margin: 60px 0 0;
        color: #ffffff;
        line-height: 36px;
        font-size: 24px;
    }
    .slogan p{
        margin: 0;
    }
    .slogan span{
        font-size: 14px;
    }
    .loader_box .progress_bar{
        flex: 1;
        height: 6px;
        border-radius: 3px;
        background: #6e6e6e;
        min-width: 200px;
    }
    .loader_box .progress_bar .speed{
        width: 0%;
        height: 6px;
        border-radius: 3px;
        background: #ffffff;
    }
    .loader_box .speed_text{
        color: #ffffff;
        font-size: 30px;
        flex: 0 0 auto;
        width: 90px;
        text-align: right;
        margin-left: 20px;
    }
    .loader_box .speed_text span{
        font-size: 40px;
    }
    .jindu{
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
    .loader_active{
      font-size: 20px !important;
    }
    @media (max-width:996px) {
      .loader_box{
        flex-wrap: wrap;
      }
      .jindu{
        margin-top: 50px;
      }
      .loader_box .speed_text span{
        font-size: 20px;
      }
      .loader_box .speed_text{
        width: auto;
        font-size: 20px;
      }
      .loader_box .progress_bar{
        min-width: 100px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue